/**
 * Feature Flags del Portal de Clientes
 *
 * Controla qué funcionalidades están habilitadas en el portal de clientes.
 * Para activar una feature, cambiar el valor a `true` y redesplegar.
 */

export const FEATURE_FLAGS = {
  /**
   * Habilita las secciones de Tareas en el portal de clientes:
   * - Card "Tareas Activas" en el dashboard
   * - Alertas relacionadas con tareas
   * - Tabs "Tareas" y "Tareas Terminadas"
   *
   * Deshabilitado temporalmente hasta que los encargados de área
   * validen y actualicen la información de tareas.
   */
  PORTAL_CLIENTE_TAREAS: false,
};
